import loopbackClient from 'react-admin-loopback';

export const dataProvider = loopbackClient('/admin')
